import React from 'react';
import PreviewSurvey from './PreviewSurvey';

/**
 * SafePreviewSurvey - A wrapper component for PreviewSurvey that ensures all question properties
 * are properly initialized to prevent runtime errors like "map is not a function"
 */
const SafePreviewSurvey = (props) => {
  // Process questions to ensure options and other array properties are always arrays
  const processedQuestions = props.questions ? props.questions.map(question => {
    if (!question) return question;
    
    return {
      ...question,
      // Ensure these properties are always arrays
      options: Array.isArray(question.options) ? question.options : [],
      choices: Array.isArray(question.choices) ? question.choices : [],
      rows: Array.isArray(question.rows) ? question.rows : [],
      columns: Array.isArray(question.columns) ? question.columns : [],
      // Ensure config is always an object
      config: question.config || {}
    };
  }) : [];

  // Pass all props to PreviewSurvey, but with processed questions
  return <PreviewSurvey {...props} questions={processedQuestions} />;
};

export default SafePreviewSurvey;